<script>
    /**
     * 下拉选择
     */
    import NormalInput from './NormalInput';
    import NormalScrollbar from './NormalScrollbar';
    import { hideOptsMixin } from '../mixin';
    import CheckBox from './CheckBox';
    import ToolTip from './ToolTip';
    // import {Segment, useDefault, cnPOSTag, enPOSTag} from 'segmentit';
    // const segmentit = useDefault(new Segment());
    // window.segmentit = segmentit;
    // window.cnPOSTag = cnPOSTag;
    // window.enPOSTag = enPOSTag;

    const CHECK_ALL_PREFIX = '::check::all::';

    export default {
        mixins: [ hideOptsMixin ],
        name: 'normal-cascader',
        data () {
            return {
                allOptions: [],
                parentName: [],
                childrenOptions: [],
                multiMap: {},
                currentLevel: 0,
                allArray: [],
                keyword: '',
                optionList: [],
                innerSelectedValue: [],
                innerSelectedList: [],
                innerSelectedText: '',
                innerCheckedList: [],
                lastText: '',
                droped: false,
                dropX: 0,
                dropY: 0,
                dropR: 0,
                minWidth: this.withSearch ? 140 : 120,
                hovering: false,
                innerSelected: this.$util.deepCopy(this.selected),
                orginOpts: [],
                originOptions: [],
                searchBarStyle: {
                    width: 120
                },
                maxInScroll: 0
            };
        },
        watch: {
            checkedList: {
                handler: function (v) {
                    console.log(v)
                    if(!v || !v.length) {
                        this.innerCheckedList = []
                        return
                    }
                    setTimeout(() => {
                        v && v.forEach(d => {
                            !this.innerCheckedList.includes(d) &&
                            this.multiMap.hasOwnProperty(d) &&
                            this.innerCheckedList.push(d);
                        });
                        let len = this.innerCheckedList.length;
                        len = len - this.innerCheckedList.filter(v => `${ v }`.includes(CHECK_ALL_PREFIX)).length;
                        if (len !== this.checkedList.length) {
                            if (this.useSlot) {
                                this.innerCheckedList = v;
                            }
                            this.$emit('check', this.innerCheckedList);
                        }
                    });
                },
                immediate: true,
                deep: true
            },
            selected: {
                handler: function (v) {
                    const result = this.$util.deepCopy(this.orginOpts);
                    this.optionList = [ result ];
                    this.innerSelectedList = [];
                    this.innerSelectedValue = v;
                    // if (!v.length && this.orginOpts.length) {
                    //     const result = this.$util.deepCopy(this.orginOpts);
                    //     this.optionList = [result];
                    // }
                },
                immediate: true,
                deep: true
            },
            options: {
                handler: function (v) {
                    if (this.variable && JSON.stringify(this.originOptions).length === JSON.stringify(v).length) {
                        return;
                    }

                    this.originOptions = this.$util.deepCopy(v);
                    setTimeout(() => {
                        this.allArray = this.getAllObj();
                    });
                    if (v.length) {
                        v = this.initOptions(v);
                        this.orginOpts = this.$util.deepCopy(v);
                        this.innerSelectedValue = this.$util.deepCopy(this.innerSelectedValue);
                        this.optionList = [ v ];
                    }
                },
                immediate: true,
                deep: true
            },
        },
        computed: {
            compCheckData () {
                return this.innerCheckedList.map(v => this.multiMap[v]).filter(v => v);
            },
            compInnerSelectedList () {
                if (!this.compare()) {
                    this.initOptionsBySelected(this.innerSelectedValue, this.optionList[0]);
                }
                return this.innerSelectedList;
            },
            compToolTipText () {
                //TODO 根据条件展示，目前只展示了 text为false，单选的情况。
                return this.compInnerSelectedText;
            },
            compInnerSelectedText: {
                set () {
                },
                get () {
                    // && !`${v}`.includes(',')  去掉筛选的重复项 father,son  和 son  就是重复项
                    const multiLen = this.innerCheckedList.filter(v => !`${ v }`.includes(CHECK_ALL_PREFIX) && !`${ v }`.includes(',')).length;
                    const multiText = multiLen ? `已选${ multiLen }项` : '';
                    const text = this.compInnerSelectedList.map(v => v.text).join(` ${ this.separation } `);
                    const item = this.innerSelectedList[this.innerSelectedList.length - 1];
                    if (!item || (item.children && item.children.length)) {
                        // 下面注释这种情况会引起单选，切换时，选择显示文案被清空的情况
                        // return this.multiple ? multiText : (text === this.lastText ? text : this.setText(text));
                        return this.multiple ? multiText : this.lastText;
                    }
                    this.setText(text);
                    return this.multiple ? multiText : this.lastText;
                }
            },
            curStyle () {
                return {
                    'margin-left': this.marginLeft * this.$cStyle.horizonMargin + 'px',
                    'margin-right': this.marginRight * this.$cStyle.horizonMargin + 'px',
                    'float': this.float,
                    'max-width': this.maxWidth ? this.maxWidth + 'px' : 'none'
                };
            },
            scrollbarInfo () {
                let max = this.maxInScroll;
                this.optionList.forEach(v => {
                    max = v.length > max ? v.length : max;
                });
                max = max * this.itemHeight;
                max = max > 244 ? 244 : max;
                if (this.maxInScroll > 0) {
                    max = this.getOptItemHeight();
                }
                this.$nextTick(() => {
                    this.maxInScroll = this.getOptItemHeight();
                    if (this.$refs.scrollbar instanceof Array) {
                        this.$refs.scrollbar.forEach(v => {
                            v.$refs.scrollView.style.minHeight = `${ this.maxInScroll }px`;
                        });
                    }
                });
                return {
                    value: max,
                    style: {
                        height: `${ max }px`
                    }
                };
            },
            dropStyle () {
                const style = {
                    opacity: this.dropOpacity,
                    top: this.dropY + 'px',
                    position: this.position
                };
                if (this.dropR) {
                    style.right = `${ this.dropR }px`;
                } else {
                    style.left = `${ this.dropX }px`;
                }
                return style;
            }
        },
        model: {
            prop: 'selected',
            event: 'select'
        },
        props: {
            variable: {
                default: false,
                required: false
            },
            withCheckedAll: {
                default: false,
                required: false
            },
            showTitle: {
                default: false,
                required: false
            },
            maxWidth: {
                default: '',
                required: false
            },
            options: {
                default () {
                    return [];
                },
                required: false
            },
            checkedList: {
                default () {
                    return [];
                },
                required: false
            },
            text: {
                default: '',
                required: false
            },
            alwaysBelow: {
                type: Boolean,
                default: false,
                required: false
            },
            selected: {
                default () {
                    return [];
                },
                required: false
            },
            theme: {
                default: 'grey',
                required: false
            },
            placeholder: {
                default: '请选择',
                required: false
            },
            inputPlaceholder: {
                default: '搜索关键词',
                required: false
            },
            marginLeft: {
                default: 0,
                required: false
            },
            marginRight: {
                default: 0,
                required: false
            },
            float: {
                default: 'left',
                required: false
            },
            disabled: {
                type: Boolean,
                default: false,
                required: false
            },
            position: {
                default: 'absolute',
                required: false
            },
            withSearch: {
                type: Boolean,
                default: false,
                required: false
            },
            customClass: {
                type: String,
                default: '',
                required: false
            },
            itemHeight: {
                type: Number,
                default: 36,
                required: false
            },
            isAutoWidth: {
                type: Boolean,
                default: true,
                required: false
            },
            separation: {
                type: String,
                default: '·',
                required: false
            },
            multiple: {
                type: Boolean,
                default: false,
                required: false
            },
            useSlot: {
                type: Boolean,
                default: false,
                required: false
            },
            //TODO 根据条件展示，目前只展示了 text为false，单选的情况。
            withToolTip: {
                type: Boolean,
                default: false,
                required: false
            }
        },
        methods: {
            setText (text) {
                this.lastText = text;
            },
            compare () {
                if (this.innerSelectedList.length !== this.innerSelectedValue.length) {
                    return false;
                }
                for (let i = 0; i < this.innerSelectedList.length; i++) {
                    if (this.innerSelectedList[i].value !== this.innerSelectedValue[i]) {
                        return false;
                    }
                }
                return true;
            },
            initOptionsBySelected (selected, opts, level = 0) {
                if (!opts || !opts.length) {
                    this.optionList[level] = [];
                    return;
                }
                if (!selected || !selected.length) {
                    selected = this.$util.deepCopy(this.innerSelectedValue);
                }
                const result = opts.filter(o => o.value === selected[level]);
                if (!result.length) {
                    this.optionList[level] = opts;
                    return;
                } else {
                    this.innerSelectedList[level] = result[0];
                }
                if (result[0].children) {
                    const selectedResult = this.initOptionsBySelected(selected, result[0].children, level + 1);
                    if (selectedResult && selectedResult.length) {
                        this.optionList[level + 1] = selectedResult;
                    }
                }
                return opts;
            },
            initOptions (opts, level = 0, parent = 0) {
                const hasCheckedAll = opts.length && `${ opts[0].value }`.includes(CHECK_ALL_PREFIX);
                if (this.withCheckedAll && !hasCheckedAll) {
                    opts.unshift(
                        {
                            level,
                            text: '全选',
                            value: `${ CHECK_ALL_PREFIX }${ parent }`,
                            parent,
                        }
                    );
                }
                opts.forEach((v) => {
                    v.level = level;
                    v.parent = parent;
                    this.multiMap[v.value] = {value: v.value, text: v.text, parent};
                    if (v.children && v.children.length) {
                        this.initOptions(v.children, level + 1, v.value);
                    }
                });
                return opts;
            },
            drop () {
                if (this.disabled === true) {
                    return false;
                }
                if (this.droped) {
                    this.fold();
                    return;
                }
                // 后加的？
                if (this.withCheckedAll) {
                    this.getChildrenOptions(this.options);
                    this.getAllOptions(this.options);
                }
                this.computePosition();

                window.addEventListener('mousedown', this.outAreaMouseDown);
            },

            computePosition () {
                // this.$refs.optionList.style.opacity = 0;
                this.droped = true;
                // var that = this;
                var rect = this.$el.getBoundingClientRect();
                this.dropX = Math.round(rect.left) + (window.pageXOffset || window.pageXOffset);
                this.dropY = Math.round(rect.top) + Math.round(rect.height + 8) + (window.pageYOffset || window.pageYOffset);
                // this.minWidth = Math.round(rect.width) - 28 - 2;
                var limitWidth = document.documentElement.clientWidth;

                this.$nextTick(() => {
                    const optRect = this.$refs.optionList.getBoundingClientRect();
                    const optWidth = optRect.width;
                    this.dropR = 0;
                    if (limitWidth - (this.dropX + optWidth) < 80) {
                        this.dropX = 0;
                        this.dropR = limitWidth - Math.round(rect.right) - (window.pageXOffset || window.pageXOffset);
                    }
                    if (this.dropR) {
                        const result = this.dropR - (optWidth / 2 - rect.width / 2);
                        this.dropR = result < rect.right ? this.dropR : result;
                        // } else {
                        // this.dropX -= (optWidth / 2 - rect.width / 2);
                    }
                    // this.$refs.optionList

                    if (this.alwaysBelow) { // 不用考虑屏幕下方不够距离的问题（即不用自适应定位去容器顶部，永远位于下方）
                        return;
                    }

                    var limitHeight = document.documentElement.clientHeight + window.pageYOffset;
                    if (limitHeight - (optRect.height + optRect.top) < 30) {
                        this.dropY = rect.top + window.pageYOffset - this.$refs.optionList.getBoundingClientRect().height - 7;
                    }
                    // setTimeout(() => {
                    //     this.$refs.optionList.style.opacity = 1;
                    // }, 100);
                });
            },

            outAreaMouseDown () {
                if (this.hovering) {
                    return;
                }

                this.fold();
            },
            fold () {
                this.droped = false;
                window.removeEventListener('mousedown', this.outAreaMouseDown);
            },
            mousedown (item, e, innerVal, itemVal) {
                let isSelected = innerVal instanceof Array ? innerVal.includes(itemVal) : innerVal === itemVal;
                if ((isSelected || item.disabled) && !this.multiple) {
                    return;
                }
                this.currentLevel = item.level;
                e.stopPropagation();
                if (this.keyword && this.withSearch) {
                    item.value = `${ item.value }`;
                    this.lastText = item.org_text;
                    this.innerSelectedList = [];
                    this.innerSelectedValue = item.value.split(',').map(v => {
                        return this.$util.validate.numberic(v) ? Number(v) : v;
                    });

                } else {
                    if (this.innerSelectedValue.length > item.level) {
                        this.innerSelectedList.splice(item.level);
                    }

                    let arrayVal = this.innerSelectedValue[item.level];
                    let arrayList = this.innerSelectedList[item.level];

                    // if (this.multiple) {
                    //     arrayVal = arrayVal || [];
                    //     arrayList = arrayList || [];
                    //
                    //     if (arrayVal.includes(item.value)) {
                    //         let idx = arrayVal.findIndex(val => val === item.value);
                    //         idx >= 0 && arrayVal.splice(idx, 1);
                    //         idx >= 0 && arrayList.splice(idx, 1);
                    //     } else {
                    //         arrayVal.push(item.value);
                    //         arrayList.push(item);
                    //     }
                    // } else {
                    arrayVal = item.value;
                    arrayList = item;
                    // }

                    this.$set(this.innerSelectedValue, item.level, arrayVal);
                    this.$set(this.innerSelectedList, item.level, arrayList);

                    if (item.children && item.children.length) {
                        this.currentLevel = item.level + 1;
                        this.optionList.splice(item.level + 1);
                        this.$set(this.optionList, item.children[0].level, item.children);

                        this.computePosition();
                        return;
                    } else {
                        if(this.multiple) {
                            setTimeout(() => {
                                this.optionList.splice(item.level + 1);
                            }, 300);
                        } else {
                            this.optionList.splice(item.level + 1);
                        }
                    }
                }
                if (!(this.keyword && this.withSearch)) {
                    this.innerSelectedValue.splice(item.level + 1);
                }

                this.computePosition();
                this.$emit('select', this.innerSelectedValue);
                this.$emit('setText', this.innerSelectedList.map(v => v.text));
                if (this.keyword && !this.multiple) {
                    this.keyword = '';
                    this.handleInput();
                }
                if (!this.multiple) {
                    this.fold();
                }
            },
            emptyFunc () {
            },
            searchFilter () {
                let keywords = this.keyword.split('').filter(v => v.trim().toLowerCase());
                keywords = [ ...new Set(keywords) ];
                const filter = this.allArray.filter(v => {
                    return keywords.every(k => {
                        return v.text.toLowerCase().includes(k);
                    });
                });
                return this.$util.deepCopy(filter).map(v => {
                    v.org_text = v.text;
                    v.text = this.$util.highLight4Join(v.text, keywords.join(''));
                    return v;
                });
            },
            searchResult2Opts (opts) {
                return opts.filter(v => !`${ v.value }`.includes(CHECK_ALL_PREFIX)).map(val => {
                    let iterator = [];
                    if (val.children && val.children.length) {
                        iterator = this.searchResult2Opts(val.children);
                    }
                    if (iterator.length) {
                        let newArray = [];
                        iterator.forEach(it => {
                            if (it instanceof Array) {
                                newArray = [ ...newArray, ...it.map(t => {
                                    return {
                                        text: `${ val.text } · ${ t.text }`,
                                        org_text: `${ val.org_text } · ${ t.org_text }`,
                                        value: `${ val.value },${ t.value }`,
                                        org_value: t.value
                                    };
                                }) ];
                            } else {
                                newArray.push({
                                    org_text: `${ val.org_text } · ${ it.org_text }`,
                                    text: `${ val.text } · ${ it.text }`,
                                    value: `${ val.value },${ it.value }`,
                                    org_value: it.value
                                });
                            }
                        });
                        return newArray;
                    } else {
                        return val;
                    }
                }).filter(v => !!v);
            },
            getAllObj () {
                const result = this.searchResult2Opts(this.$util.deepCopy(this.orginOpts));
                let array = [];
                result.forEach(v => {
                    if (v instanceof Array) {
                        array = [ ...array, ...v ];
                    } else {
                        array.push(v);
                    }
                });
                return array;
            },
            handleInput () {
                if (!this.keyword) {
                    this.optionList = [ this.$util.deepCopy(this.options) ];
                    this.initOptionsBySelected(this.selected, this.optionList[0]);
                    return;
                }
                const result = this.searchFilter();
                this.optionList = result.length ? [ result ] : [];
            },

            // 递归拿到所有有children的选项(有后代的选项)
            getChildrenOptions (option) {
                for (let i = 0; i < option.length; i++) {

                    if (option[i].children && option[i].children.length !== 0) {
                        this.childrenOptions.push(option[i]);
                        this.getChildrenOptions(option[i].children);
                    }
                }
            },
            // 递归拿到所有选项(没有后代的选项)
            getAllOptions (option) {
                for (let t = 0; t < option.length; t++) {

                    if ((!option[t].children || option[t].children.length == 0) && !`${ option[t].value }`.includes(CHECK_ALL_PREFIX)) {
                        this.allOptions.push(option[t]);
                    } else if ((option[t].children && option[t].children.length !== 0) && !`${ option[t].value }`.includes(CHECK_ALL_PREFIX)) {
                        this.getAllOptions(option[t].children);
                    }
                }
            },

            // 找到点了全选(不包括0级)之后 拿到当前要遍历的对象
            findNowOptions (value) {
                for (let k = 0; k < this.childrenOptions.length; k++) {
                    if (this.childrenOptions[k].value == value) {
                        return this.childrenOptions[k];
                    }
                }
            },
            // 递归拿到点了全选(不包括0级) 之后 “要被打勾的所有选项” 的parent值
            findParentName (option) {
                for (let i = 0; i < option.length; i++) {
                    if (option[i].children && option[i].children.length !== 0) {
                        this.parentName.push(option[i].children[0].parent);
                        this.findParentName(option[i].children);
                    }
                }
            },
            // 点击全选(不包括0级) 该全选影响到的需要被打勾的选项（同一级、下一级、下下级...）
            getList (value) { //当前全选按钮的parent的value
                this.parentName = [ value ];
                let option = this.findNowOptions(value);
                option && this.findParentName(option.children);
                let list = [];
                for (let i = 0; i < this.allOptions.length; i++) {
                    // 通过parent值找出那些选项要被打勾
                    if (this.parentName.includes(this.allOptions[i].parent)) {
                        list.push(this.allOptions[i]);
                    }
                }
                return list;
            },
            // 判断所有全选按钮的状态
            isCheckedAll () {
                // 判断0级全选按钮的状态
                if (this.allOptions.every(v => this.innerCheckedList.includes(v.value))) {
                    !this.innerCheckedList.includes(`${ CHECK_ALL_PREFIX }0`) && this.innerCheckedList.push(`${ CHECK_ALL_PREFIX }0`);
                } else {
                    this.innerCheckedList.includes(`${ CHECK_ALL_PREFIX }0`) && (this.innerCheckedList = this.innerCheckedList.filter(v => !(v.includes(`${ CHECK_ALL_PREFIX }0`))));
                }
                // 循环判断其他级全选按钮的状态
                for (let i = 0; i < this.childrenOptions.length; i++) {
                    let list = this.getList(this.childrenOptions[i].value);
                    const prefix = `${ CHECK_ALL_PREFIX }${ this.childrenOptions[i].value }`;
                    if (list.length && list.every(v => this.innerCheckedList.includes(v.value))) {
                        !this.innerCheckedList.includes(prefix) && this.innerCheckedList.push(prefix);
                    } else {
                        this.innerCheckedList.includes(prefix) && (this.innerCheckedList = this.innerCheckedList.filter(v => !(v.includes(prefix))));
                    }
                }
            },
            handleCheck (item, $e) {
                // 如果value值是数字 变成字符串
                item.value = item.value + '';
                // item是全选按钮
                if (this.withCheckedAll && `${ item.value }`.includes(CHECK_ALL_PREFIX)) {
                    let list = [];//list存放当前全选按钮的parent下的所有子级
                    //0级全选按钮
                    if (item.value === `${ CHECK_ALL_PREFIX }0`) {
                        list = this.allOptions;
                    } else { //其他级全选按钮
                        list = this.getList(item.parent);
                    }

                    if ($e) {//全选按钮打勾
                        list.forEach(v => {
                            // this.handleCheck(v,$e)//感觉这样递归性能会比较差 改成
                            !this.innerCheckedList.includes(v.value) && this.innerCheckedList.push(v.value);
                        });
                    } else {
                        if (list.length && list.every(v => this.innerCheckedList.includes(v.value))) {//这句判断是为了区分全不选和反选 不要让反选触发了全不选
                            list.forEach(v => {//全不选
                                // this.handleCheck(v,$e)
                                let idx = this.innerCheckedList.findIndex(val => val === v.value);
                                idx >= 0 && this.innerCheckedList.splice(idx, 1);
                            });
                        }
                    }
                    // 点击全选按钮 也要传新的数组出去
                    this.$emit('check', this.innerCheckedList.filter(v => !`${ v }`.includes(CHECK_ALL_PREFIX) && !`${ v }`.includes(',')));

                } else {//item非全选按钮
                    let idx = this.innerCheckedList.findIndex(val => val === item.value);
                    // -1表示不包含该元素  >0则表示包含并且是它的索引位置
                    let len = this.innerCheckedList.length;
                    if ($e) {
                        idx === -1 && this.innerCheckedList.push(item.value);
                    } else {
                        idx >= 0 && this.innerCheckedList.splice(idx, 1);//innerCheckedList去掉该选项
                    }
                    clearTimeout(this.checkTimer);
                    this.checkTimer = setTimeout(() => {
                        len !== this.innerCheckedList.length && this.$emit('check', this.innerCheckedList.filter(v => !`${ v }`.includes(CHECK_ALL_PREFIX) && !`${ v }`.includes(',')));
                    }, 500);
                }
                clearTimeout(this.allCheckTimer);
                this.allCheckTimer = setTimeout(() => {
                    this.isCheckedAll();//更新所有全选按钮的状态
                }, 500);
                if (this.keyword && this.withSearch) {
                    item.value = this.innerSelectedValue[this.innerSelectedValue.length - 1];
                }

            },
            getOptItemHeight () {
                let data = Number.MAX_VALUE;
                if (this.$refs.optionList) {
                    const array = Array.from(this.$refs.optionList.querySelectorAll('.item'));
                    if (array.length) {
                        data = array.map(el => el.getBoundingClientRect().height).reduce((a, b) => a + b);
                    }
                }
                return data > 244 ? 244 : data;
            }
        },
        beforeDestroy () {
            document.body.removeChild(this.$refs.optionList);
        },
        mounted () {
            document.body.appendChild(this.$refs.optionList);
        },
        components: {
            CheckBox,
            NormalInput,
            NormalScrollbar,
            ToolTip
        }
    };
</script>

<template>
    <div class="drop-frame normal-cascader"
         @click.stop="drop"
         @mouseenter="hovering = true"
         @mouseleave="hovering = false"
         v-bind:class="[theme,
            {disabled: disabled}, {'active': droped, 'use-slot': useSlot}
         ]"
         v-bind:style="curStyle"
         :title="showTitle ? compInnerSelectedText : ''">
        <template v-if="useSlot">
            <slot v-bind:checked="compCheckData"></slot>
        </template>
        <template v-else>
            <tool-tip position="bottom"
                      :content="compToolTipText"
                      :tipWidth="450"
                      :disabled="!withToolTip"
                      :openDelay="200">
                <normal-input float="none"
                              v-show="!text"
                              :is-auto-width="isAutoWidth"
                              :readonly="true"
                              :placeholder="placeholder"
                              :disabled="disabled"
                              suffix-icon="&#xe69e;"
                              v-model="compInnerSelectedText">
                </normal-input>
            </tool-tip>
            <normal-input float="none"
                          v-show="text"
                          :is-auto-width="false"
                          :readonly="true"
                          :disabled="disabled"
                          suffix-icon="&#xe69e;"
                          v-model="text">
            </normal-input>
        </template>
        <transition name="fade">
            <div class="option-list"
                 @mousedown.stop="emptyFunc"
                 ref="optionList"
                 v-show="droped"
                 :class="{'with-search':withSearch, [customClass]: !!customClass}"
                 v-bind:style="dropStyle">
                <div class="search-bar"
                     v-if="withSearch">
                    <normal-input
                        class="search-input"
                        v-model="keyword"
                        @input="handleInput"
                        float="none"
                        type="text"
                        autocomplete="off"
                        suffix-icon="&#xe686;"
                        :placeholder="inputPlaceholder"
                    ></normal-input>
                </div>

                <div class="flex-wrap">
                    <template v-if="optionList.length">
                        <normal-scrollbar :height="scrollbarInfo.value"
                                          :style="scrollbarInfo.style"
                                          ref="scrollbar"
                                          class="option-list-wrap cascader-options-warp"
                                          v-for="(opt,key) in optionList" :key="key">

                            <template v-if="maxWidth">
                                <div class="item"
                                     v-for="item in opt"
                                     :key="item.value"
                                     :class="[{
                                        active: innerSelectedValue[key] === item.value,
                                        'has-children': item.children && item.children.length,
                                        disabled: item.disabled
                                     } ]"
                                     @mousedown="mousedown(item, $event,innerSelectedValue[key] , item.value)"
                                     :style="{'min-width': minWidth + 'px', 'max-width': item.level === currentLevel ? '400px' : '200px'}">
                                    <template v-if="multiple && (!item.children || !item.children.length)">
                                        <check-box :checked="innerCheckedList.includes(item.value)"
                                                   style="width: 100%"
                                                   @check="handleCheck(item, $event)"
                                                   :text="item.text"></check-box>
                                    </template>
                                    <span v-else class="max-width-text-hidden item-text"
                                          :title='item.text.length > 10 ? item.text :""'
                                          v-html="item.text"></span>
                                </div>
                            </template>
                            <template v-else>
                                <div class="item"
                                     v-for="item in opt"
                                     :key="item.value"
                                     :class="[{
                                        active: multiple ? (innerCheckedList.includes(item.value) || (innerSelectedValue[key] === item.value && ( item.children && item.children.length))) : innerSelectedValue[key] === item.value,
                                        'has-children': item.children && item.children.length,
                                        disabled: item.disabled,
                                        'last': multiple && (!item.children || !item.children.length)
                                    } ]"
                                     @mousedown="mousedown(item, $event,innerSelectedValue[key] , item.value)"
                                     :style="{'min-width': minWidth + 'px'}">
                                    <template v-if="multiple && (!item.children || !item.children.length)">
                                        <!-- :checked="innerCheckedList.includes((keyword && withSearch) ? item.org_value : item.value)"这样有个问题 只有一级的选项无org_value -->
                                        <check-box
                                            :checked="innerCheckedList.includes((keyword && withSearch) ? (item.org_value ? item.org_value : item.value ) : item.value)"
                                            style="width: 100%"
                                            @check="handleCheck(item, $event)"
                                            :text="item.text "></check-box>
                                    </template>
                                    <span v-else class="item-text" v-html="item.text"></span>
                                </div>
                            </template>
                        </normal-scrollbar>
                    </template>
                    <div class="no-match" v-if="withSearch && keyword && !optionList.length">无匹配结果</div>
                </div>
            </div>
        </transition>
    </div>
</template>
<style lang="less" scoped>
    @import '../../assets/less/widgets-var.less';


    div.drop-frame.no-border {
        /*display: inline-block;*/
        border-color: transparent;

        > .selected {
            padding: 0 23px 0 0px;
            font-size: 14px;
        }
    }

    .drop-frame {
        width: auto;
        height: @widgetsHeight;
        line-height: @widgetsHeight;
        margin: (@lineHeight - @widgetsHeight)/2 0;

        &.use-slot {
            border-radius: 5px;
            min-width: 140px;
            border: 1px solid @otherIptSelTipsDisbaledClr;
            padding: 0 30px 0 10px;

            &:after {
                width: 20px;
                text-align: right;
                height: 20px;
                font-family: cmsicon;
                position: absolute;
                right: 10px;
                top: 50%;
                margin-top: -10px;
                line-height: 20px;
                color: @otherBtnBorderNoteClr;
                font-size: 14px;
                content: '\e69e';
            }
        }

        > .selected {
            width: auto;
            min-width: 1px;
            height: @widgetsHeight - 2;
            line-height: @widgetsHeight;
            text-align: center;
            overflow: hidden;
            padding: 0 26px+14 0 14px;
            margin: 0;
            position: relative;
            font-size: 14px;
            cursor: pointer;
        }

        /deep/ .normal-input {
            max-width: 100%;
        }
    }

    .option-list {
        background-color: #fff;
        box-shadow: 0px 0px 4px 0px rgba(17, 6, 85, 0.16);
        width: auto;
        height: auto;
        min-width: 1px;
        min-height: 1px;
        max-height: 300px;
        overflow: hidden;
        z-index: 99999;
        box-sizing: border-box;
        padding: 6px 0;
        border-radius: @widgetsBorderRadius;

        .flex-wrap {
            display: flex;
            justify-content: flex-start;

            .no-match {
                color: @otherIptSelTipsDisbaledClr;
                text-align: center;
                line-height: @lineHeight;
                font-size: 14px;
                width: 100%;
                min-width: 240px;
            }
        }

        .option-list-wrap {
            border-right: 1px solid @otherBorderClr;

            &:last-child {
                border-right: none;
            }
        }

        .search-bar {
            overflow: hidden;
            width: 100%;
            padding: 0 10px;
            box-sizing: border-box;
            position: absolute;
            left: 0;
            top: 6px;
            right: 0;
            height: 50px;

            .normal-input {
                min-width: 120px;
            }
        }

        &.with-search {
            padding-top: 56px;
            min-width: 140px;
        }

        .item {
            width: auto;
            overflow: hidden;
            clear: both;
            margin: 0;
            min-height: @widgetsHeight;
            //line-height: @widgetsHeight;
            padding: 5px 28px 5px 14px;
            font-size: 14px;
            color: @otherTextClr;
            cursor: pointer;
            position: relative;
            box-sizing: border-box;
            max-width: 450px;
            display: flex;
            align-items: center;
            justify-content: flex-start;

            .item-text {
                display: inline-block;
                padding-right: 20px
            }

            .check-box {
                margin: 0;
            }

            .max-width-text-hidden {
                max-width: 100%;
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
            }


            &.disabled {
                color: @otherDisabledBgClr;
                cursor: not-allowed !important;
                pointer-events: auto;
            }


            &.active {
                color: @primaryBg;

                &:after {
                    color: @primaryBg;
                }
            }

            &.has-children {
                &:after {
                    font-family: cmsicon;
                    content: '\e697';
                    position: absolute;
                    right: 12px;
                    font-size: 12px;
                    top: 50%;
                    transform: translateY(-50%);
                    bottom: 0;
                    //line-height: 36px;
                }
            }
        }

        .item:hover {
            background-color: @otherBtnHoverClr;
        }


    }

</style>
